import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { AccionesDialog } from '@models/base/identificadores.model';
import { GrupoTipoGarantiaInquilinoDto } from '@models/grupos-tipo-garantia-inquilino/grupoTipoGarantiaInquilinoDto.model';
import { InquilinoDto } from '@models/inquilino/inquilinoDto.model';
import { RenterDeliveredNecessaryGuaranteesResponse } from '@models/inquilino/renterDeliveredNecessaryGuaranteesResponse.model';
import { GruposTipoGarantiaInquilinoService } from '@services/grupos-tipo-garantia-inquilino/grupos-tipo-garantia-inquilino.service';
import { InquilinosService } from '@services/inquilinos/inquilinos.service';
import { PersonasService } from '@services/personas/personas.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { DialogGruposTipoGarantiaInquilinoComponent } from '@views/grupos-tipo-garantia-inquilino/dialog-grupos-tipo-garantia-inquilino/dialog-grupos-tipo-garantia-inquilino.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { distinctUntilChanged, filter, map, takeUntil } from 'rxjs/operators';
import { isFalsy } from 'utility-types';

@Component({
  selector: 'app-estado-garantias-pendientes',
  templateUrl: './estado-garantias-pendientes.component.html',
  styleUrls: ['./estado-garantias-pendientes.component.css']
})
export class EstadoGarantiasPendientesComponent implements OnInit, OnDestroy {

  /** Corta la suscripción al destruirse el componente */
  private destroy$ = new Subject<void>()

  ejecutado: boolean = false
  data = false

  /**
   * Arranca en true a propósito: hasta que la primera consulta no responde no se
   * sabe si el inquilino ya tiene grupo. Si arrancara en false, el botón de
   * "Grupos de Garantías por Inquilino" aparecería un instante y se escondería
   * solo, invitando a crear un grupo duplicado.
   */
  cargando = true
  renterDeliveredNecessaryGuaranteesResponse!: RenterDeliveredNecessaryGuaranteesResponse;
  grupoTipoGarantiaInquilinoDto!: GrupoTipoGarantiaInquilinoDto;
  displayedColumns: string[] = ['inquilino', 'grupoTipoGarantia', 'idGrupo', 'accion'];
  dataSource = new MatTableDataSource<GrupoTipoGarantiaInquilinoDto>();
  inquilinoDto!: InquilinoDto;
  constructor(public inquilinosService: InquilinosService,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private snackBar: SnackBarService,
    private inquilinoService: InquilinosService,

    private personasService: PersonasService,

    private router: Router,
    private gruposTipoGarantiaInquilinoService: GruposTipoGarantiaInquilinoService,) {
  }

  /**
   * UNA sola suscripción, acá.
   *
   * Antes el mismo bloque estaba repetido en el constructor, en ngOnInit y en
   * ngOnChanges. Como inquilinoDto es un BehaviorSubject, cada suscripción
   * dispara de inmediato, así que eran tres tandas de llamadas por cada emisión.
   * Y ngOnChanges corre en cada cambio de entrada: sumaba una suscripción nueva
   * cada vez, sin dar de baja las anteriores, así que la cantidad de llamadas
   * crecía mientras la pantalla estaba abierta.
   *
   * distinctUntilChanged por id evita volver a pedir lo mismo cuando el objeto
   * cambia de instancia pero sigue siendo el mismo inquilino.
   */
  ngOnInit() {
    this.inquilinosService.inquilinoDto
      .pipe(
        filter(data => !isFalsy(data) && !isFalsy(data.id) && data.id > 0),
        map(data => data),
        distinctUntilChanged((anterior, actual) => anterior.id === actual.id),
        takeUntil(this.destroy$)
      )
      .subscribe(data => {
        this.inquilinoDto = data
        this.getAllGruposTiposGarantiaInquilino()
        this.renterDeliveredNecessaryGuarantees(this.inquilinoDto.id)
      });

    /**
     * Cuando se valida o se invalida una garantía desde la tarjeta de al lado,
     * las pendientes ya no son las mismas. El aviso llega recién cuando la API
     * confirmó el cambio, así que acá se puede volver a preguntar sin miedo a
     * leer el estado viejo.
     */
    this.inquilinosService.garantiasCambiadas$
      .pipe(takeUntil(this.destroy$))
      .subscribe(idInquilino => {
        if (!isFalsy(idInquilino) && idInquilino > 0)
          this.renterDeliveredNecessaryGuarantees(idInquilino)
      })
  }

  ngOnDestroy() {
    this.destroy$.next()
    this.destroy$.complete()
  }

  getAllGruposTiposGarantiaInquilino() {
    this.cargando = true
    this.spinner.show()
    this.gruposTipoGarantiaInquilinoService.getAll()
      .subscribe(
        data => {
          this.spinner.hide()
          this.dataSource.data = data.filter(x => x.inquilino && x.inquilino.id === this.inquilinoDto.id);
          this.data = this.dataSource.data.length >= 1 ? true : false
          this.cargando = false
        },
        error => {
          this.snackBar.showError(error, "Error");
          this.spinner.hide()
          this.cargando = false
        }
      )
  }

  editarPersona(persona: any) {
    this.getPersonaById(persona.id)
  }

  getPersonaById(idPersona: number) {
    this.spinner.show()
    if(!isFalsy(idPersona))
    this.personasService.getPersonaById(idPersona)
      .subscribe(
        data => {
          this.spinner.hide()
          this.personasService.setPersona(data)
          this.router.navigate(["/personas/editar"])
        },
        error => {
          this.spinner.hide()
          this.snackBar.showError(error, "Error");
        });
  }




  //Validar Garantias Inquilino
  renterDeliveredNecessaryGuarantees(idInquilino: number) {
    // El show estaba antes del if: si el id venía vacío, el spinner quedaba
    // girando para siempre porque no había subscribe que lo apagara.
    if (isFalsy(idInquilino))
      return

    this.spinner.show("spCargarEstado")
    this.inquilinosService.renterDeliveredNecessaryGuarantees(idInquilino)
      .subscribe(
        data => {
          this.spinner.hide("spCargarEstado")
          this.renterDeliveredNecessaryGuaranteesResponse = data
        },
        error => {
          this.spinner.hide("spCargarEstado")
        }
      )
  }

  openDialog(action: any, obj: { action?: any; inquilinoDto?: any; }) {
    obj.action = action;
    obj.inquilinoDto = this.inquilinoDto
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.data = obj
    dialogConfig.width = "35%"

    const dialogRef = this.dialog.open(DialogGruposTipoGarantiaInquilinoComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      // Faltaban las llaves: renterDeliveredNecessaryGuarantees quedaba fuera del
      // if y se ejecutaba también al cancelar, consultando de gusto.
      if (result && result.event != AccionesDialog.Cancelar) {
        this.getAllGruposTiposGarantiaInquilino()
        this.renterDeliveredNecessaryGuarantees(this.inquilinoDto.id)
      }
    });
  }

  isFalsy(valor: any) {
    return isFalsy(valor)
  }

  trackByItems(index: number, item: any): any { return item; }

}
